// extracted by css-extract-rspack-plugin
var _1 = "gu";
var _2 = "fm";
export { _1 as "discountCouponCode", _2 as "discountCouponComponent" }
